import { render } from "./DatasetManagementLinkCard.vue?vue&type=template&id=03d53d5b&scoped=true&ts=true"
import script from "./DatasetManagementLinkCard.vue?vue&type=script&lang=ts"
export * from "./DatasetManagementLinkCard.vue?vue&type=script&lang=ts"

import "./DatasetManagementLinkCard.vue?vue&type=style&index=0&id=03d53d5b&lang=scss&scoped=true"

import exportComponent from "/dati01/var/lib/jenkins/workspace/Sub_Task_Release_CE/knowage-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03d53d5b"]])

export default __exports__